import _toConsumableArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { forwardRef } from 'react';
import { useUncontrolled } from '@mantine/hooks';
import { useComponentDefaultProps } from '@mantine/styles';
import { SwitchGroupProvider } from '../SwitchGroup.context.js';
import { Input } from '../../Input/Input.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var defaultProps = {
  size: "sm"
};
var SwitchGroup = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("SwitchGroup", defaultProps, props),
      children = _a.children,
      value = _a.value,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      size = _a.size,
      wrapperProps = _a.wrapperProps,
      others = __objRest(_a, ["children", "value", "defaultValue", "onChange", "size", "wrapperProps"]);

  var _useUncontrolled = useUncontrolled({
    value,
    defaultValue,
    finalValue: [],
    onChange
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      _value = _useUncontrolled2[0],
      setValue = _useUncontrolled2[1];

  var handleChange = function handleChange(event) {
    var itemValue = event.currentTarget.value;
    setValue(_value.includes(itemValue) ? _value.filter(function (item) {
      return item !== itemValue;
    }) : [].concat(_toConsumableArray(_value), [itemValue]));
  };

  return /* @__PURE__ */React.createElement(SwitchGroupProvider, {
    value: {
      value: _value,
      onChange: handleChange,
      size
    }
  }, /* @__PURE__ */React.createElement(Input.Wrapper, __spreadValues(__spreadValues({
    labelElement: "div",
    size,
    __staticSelector: "SwitchGroup",
    ref
  }, wrapperProps), others), children));
});
SwitchGroup.displayName = "@mantine/core/SwitchGroup";
export { SwitchGroup };